module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1038-7f14daa8cdcc5077da27ace1733cb52f.png";